import { Body, Dialog, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { Column } from '../../../../components/Layout/Column'

const TextContainer = styled.div`
    margin: auto;
    max-width: 560px;
    text-align: center;
`

export const CantPayBillDialog: React.FC<{
    open: boolean
    onClose: () => void
}> = ({ onClose, open, children }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <Dialog.Content minWidth={560} style={{ minHeight: 200, padding: 0 }}>
                <TextContainer>
                    <Column align="center">
                        <Spacer height={32} />
                        <Body.SmBold size={14}>We need to verify this bill</Body.SmBold>
                        <Spacer height={16} />
                        <Body.Med size={14} align="center">
                            Hmm... It looks like we need to verify this bill before you can make a
                            payment. Don't worry, you don't need to do anything else. This process
                            usually takes 24-48 hours and we'll send you an email when you can make
                            a payment to this account.
                        </Body.Med>
                        <Spacer height={24} />
                        {children}
                        <Spacer height={16} />
                    </Column>
                </TextContainer>
            </Dialog.Content>
        </Dialog>
    )
}
